/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Collapse from '../atoms/collapse';
import Plus from '../atoms/plus';
import { media } from '../../utils/media-queries';
import { useWindowSize } from '../../hooks/useWindowSize';

const Accordion = ({
  headline,
  children,
  light,
  last = false,
  subheadline,
  className,
  dark,
  onClick,
  active,
  inactive,
}) => {
  const borderColor = {
    borderColor: light ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 70, 40, 0.2)',
  };
  const removeBorder = { borderColor: 'rgba(0, 0, 0, 0.0)' };

  const buttonColor = {
    color: active ? 'var(--red)' : 'var(--black)',
  };

  const accordionRef = useRef();
  const contentRef = useRef();

  const [isMobile, setIsMobile] = useState(false);
  const [fade, setFade] = useState(false);

  const size = useWindowSize();

  useEffect(() => {
    setIsMobile(size.width < 900);
  }, [size]);

  useEffect(() => {
    if (contentRef.current) {
      if (
        contentRef.current.getBoundingClientRect().height >
        accordionRef.current.getBoundingClientRect().height
      ) {
        setFade(true);
      } else {
        setFade(false);
      }
    }
  }, [inactive, active, onClick, size]);

  return (
    <StyledAccordion
      style={!last ? borderColor : removeBorder}
      className={className}
      inactive={inactive}
      ref={accordionRef}
      fade={fade}
    >
      <div role="button" className="button" onClick={onClick}>
        <Plus
          triggerAnim={active}
          light={light}
          dark={dark}
          inactive={inactive}
        />
        {isMobile ? (
          <div>
            <p style={buttonColor} className="hl-item">
              {headline}
            </p>
            {subheadline && <p style={buttonColor}>{subheadline}</p>}
          </div>
        ) : (
          <>
            <p style={buttonColor} className="hl-item">
              {headline}
            </p>
            {subheadline && <p style={buttonColor}>{subheadline}</p>}
          </>
        )}
      </div>
      <Collapse active={active}>
        <div className="content" ref={contentRef}>
          {children}
        </div>
      </Collapse>
    </StyledAccordion>
  );
};

const StyledAccordion = styled.div`
  border-bottom-style: solid;
  border-bottom-width: 1px;
  pointer-events: ${(props) => (props.inactive ? 'none' : 'all')};

  &.team {
    p {
      color: var(--red) !important;
    }

    .button {
      padding: var(--sp-1-3);
    }
  }

  .button {
    cursor: pointer;
    display: flex;
    padding: var(--sp-3) 0;
    transition: 0.3s;
    justify-content: space-between;
    font-size:1.6rem;

    p {
      padding-left: var(--sp-5);
      width: 100%;
    }
  }

  .content {
    color: var(--red);
    font-size: var(--fs-small);
    padding-bottom: var(--sp-1-3);
  }

  .collapse {
    // mask-image: linear-gradient(
    //   to bottom,
    //   black ${(props) => (props.fade ? `70%` : `100%`)},
    //   transparent 100%
    // );
  }

  @media ${media.M} {
    .button {
      justify-content: flex-start;
      font-size:2.0rem;

      p {
        padding-left: var(--sp-13);
      }
    }

    .content {
      padding-left: var(--sp-13);
      padding-bottom: var(--sp-3);
    }
  }
`;

Accordion.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  light: PropTypes.bool,
  dark: PropTypes.bool,
  last: PropTypes.bool,
};

export default Accordion;
